import { createTRPCReact } from "@trpc/react-query";
import { httpBatchLink } from "@trpc/client";
import type { AppRouter } from "@server/trpc/routers/index.js";

export const trpc = createTRPCReact<AppRouter>();

export function createTRPCClient() {
  const apiUrl = import.meta.env.VITE_API_URL || "";
  return trpc.createClient({
    links: [
      httpBatchLink({
        url: `${apiUrl}/api/trpc`,
        fetch(url, options) {
          return fetch(url, { ...options, credentials: "include" });
        },
      }),
    ],
  });
}
